'use client';

import { Skeleton } from '@common/components';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';

import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface HeroImageProps {
  heroImageUrlList: string[];
  adultYN: boolean;
}

export const HeroImage = ({ heroImageUrlList, adultYN }: HeroImageProps) => {
  //* SSR 및 초기 렌더링 시 데스크톱으로 가정하여 데스크톱일 때 초기 이미지 로딩 방지
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: 'start',
  });

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);

    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <div className="relative w-full">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {heroImageUrlList.map((url, index) => (
            <div
              key={index}
              className="relative aspect-square min-w-0 flex-[0_0_100%]"
            >
              {/* 데스크톱에서는 이미지 불러오지 않도록 */}
              {!isDesktopViewport ? (
                <Image
                  src={url}
                  alt="답례품 히어로이미지"
                  fill
                  sizes="(max-width: 768px) 100vw, 500px"
                  className="object-cover"
                  loading="lazy"
                  preload={index === 0}
                />
              ) : (
                <Skeleton className="absolute size-full" />
              )}
              {adultYN && (
                <div className="absolute left-20 top-20 rounded-xsmall bg-B-500 px-12 py-4 font-600 text-Gray-white typo-body4">
                  19세이상 구매가능
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="absolute bottom-16 right-16 w-fit rounded-pill bg-Gray-black/20 px-8 py-2 font-600 text-Gray-white typo-caption2">
        {selectedIndex + 1} / {heroImageUrlList.length}
      </div>
    </div>
  );
};
